import Service from '@/api/service';
import i18n    from '@/lang';

let cachedIds = {};

export function clearCache() {

  cachedIds = {};
}

export async function getKeyValue(tenantId, id, model, options = {}) {

  try {

    const name = await getName(tenantId, id, model, options);

    return { key : id, value : name };
  } catch {

    return { key : id, value : 'Unknown', invalid : true };
  }
}

export async function getKeyValueArray(tenantId, array) {

  if (!array || !Array.isArray(array)) {
    return [];
  }

  const keyValueArray = [];
  for (const id of array) {

    const keyValue = await getKeyValue(tenantId, id);
    keyValueArray.push(keyValue);
  }

  return keyValueArray;
}

export async function getKeyValueProfilArray(tenantId, array) {

  if (!array || !Array.isArray(array)) {
    return [];
  }

  const keyValueArray = [];
  for (const id of array) {

    const keyValue = await getKeyValueProfile(tenantId, id);
    keyValueArray.push(keyValue);
  }

  return keyValueArray;
}

export async function getKeyValueProfile(tenantId, id) {

  try {

    const name = await getName(tenantId, id);

    let hash = 0;
    if (!name) {
      return { key : id, value : 'Unknown', invalid : true };
    }

    for (const char of name.split('')) {
      hash = (hash << 8 - hash) + char.charCodeAt(0);
    }

    let color = `#${ Math.abs(hash).toString(16).substring(0, 6) }`;
    while (color.length < 7) {
      color += '9';
    }

    return { key : id, value : name, color : color };
  } catch {

    return { key : id, value : 'Unknown', invalid : true };
  }
}

export async function getName(tenantId, id, model, options = {}) {

  if (id.startsWith('USR')) {

    if (cachedIds[id]) {
      return getFirstAndLastName(cachedIds[id], options);
    }

    const user = await Service.getUser(tenantId, id);
    cachedIds[id] = user;
    return getFirstAndLastName(user, options);
  }

  if (id.startsWith('CLI')) {

    if (cachedIds[id]) {
      return getFirstAndLastName(cachedIds[id], options);
    }

    const client = await Service.getClient(tenantId, id);
    cachedIds[id] = client;
    return getFirstAndLastName(client, options);
  }

  if (id.startsWith('COM')) {

    if (cachedIds[id]) {
      return cachedIds[id].name;
    }

    const company = await Service.getCompany(tenantId, id);
    cachedIds[id] = company;
    return company.name;
  }

  if (id.startsWith('NOT')) {

    if (cachedIds[id]) {
      return getFirstAndLastName(cachedIds[id], options);
    }

    const notary = await Service.getNotary(tenantId, id);
    cachedIds[id] = notary;
    return getFirstAndLastName(notary, options);
  }

  if (id.startsWith('ADA')) {

    if (cachedIds[id]) {

      const ada = cachedIds[id];
      return ada.category === 'company' ? ada.companyName : getFirstAndLastName(ada, options);
    }

    const ada = await Service.getAda(tenantId, id);
    cachedIds[id] = ada;
    return ada.category === 'company' ? ada.companyName : getFirstAndLastName(ada, options);
  }

  if (id.startsWith('CDN')) {

    if (cachedIds[id]) {
      return getFirstAndLastName(cachedIds[id], options);
    }

    const clerk = await Service.getClerk(tenantId, id);
    cachedIds[id] = clerk;
    return getFirstAndLastName(clerk, options);
  }

  if (model === 'lead') {

    if (cachedIds[id]) {
      return cachedIds[id].name[i18n.global.locale];
    }

    const lead = await Service.getLead(tenantId, id);
    cachedIds[id] = lead;
    return lead.name[i18n.global.locale];
  }

  if (model === 'partner') {

    if (cachedIds[id]) {
      return cachedIds[id].name;
    }

    const partner = await Service.getPartner(tenantId, id);
    cachedIds[id] = partner;
    return partner.name;
  }
}

export function getFirstAndLastName(name, options = {}) {

  if (options.lastNameFirst) {

    return `${ name.lastName.toUpperCase() } ${ name.firstName }`;
  }

  return `${ name?.firstName } ${ name?.lastName?.toUpperCase() }`;
}

export function getKeyValueTrad(type, value) {

  let tradMessages = i18n.global.messages[i18n.global.locale];
  for (const text of type.split('.')) {

    tradMessages = tradMessages[text];
  }

  return { key : value, value : tradMessages[value] };
}

export function centToEuro(value, digit = 2) {

  return Number((value / 100).toFixed(digit));
}

export function euroToCent(value) {

  const val = Number(value);
  const cents = Math.round(val * 100);
  return centToEuro(cents) === val ? cents : Math.floor(val * 100);
}
